import cns from "classnames";
import { PropsWithChildren, useState } from "react";
import AnimateHeight from "react-animate-height";

import styles from "./index.module.scss";

export type AccordionProps = PropsWithChildren & {
    className?: string;
    title: string;
    defaultOpen?: boolean;
};

const Accordion: React.FC<AccordionProps> = ({
    className,
    title,
    children,
    defaultOpen,
}) => {
    const [height, setHeight] = useState<"auto" | number>(
        defaultOpen ? "auto" : 0
    );

    const handleButtonClick = () => {
        setHeight(height === 0 ? "auto" : 0);
    };

    return (
        <div
            className={cns(className, styles.component, {
                isOpen: height === "auto",
            })}
        >
            <button
                className={cns(
                    styles.component__button,
                    "text text_h5 text_uppercase"
                )}
                type="button"
                onClick={handleButtonClick}
            >
                {title}
                <div className={styles.component__buttonIcon}></div>
            </button>

            <AnimateHeight
                className={styles.component__body}
                contentClassName={styles.component__content}
                duration={500}
                height={height}
            >
                {children}
            </AnimateHeight>
        </div>
    );
};

export default Accordion;
